// src/components/PhotoEditorOverlay.jsx
import React, { useContext } from 'react';
import { MediaOverlayContext } from '../../context/MediaOverlayContext';
import './PhotoEditorOverlay.css';

const PhotoEditorOverlay = () => {
  const {
    photos,
    activePhotoIndex,
    updatePhotoAtIndex,
    closePhotoEditor,
    availableDogs
  } = useContext(MediaOverlayContext);

  console.log('activePhotoIndex', activePhotoIndex);
  console.log('activePhotoIndex >= photos.length', activePhotoIndex >= photos.length);
  console.log('!photos[activePhotoIndex]', !photos[activePhotoIndex]);


  if (
    activePhotoIndex === null ||
    activePhotoIndex >= photos.length ||
    !photos[activePhotoIndex]
  ) return null;



  const photo = photos[activePhotoIndex];

  const updateChecklist = (key, value) => {
    const updatedChecklist = { ...photo.checklist, [key]: value };
    updatePhotoAtIndex(activePhotoIndex, { checklist: updatedChecklist });
  };

  const updateCaption = (key, value) => {
    updateChecklist(key, value);
  };

  const addTag = (dogId) => {
    if (!photo.tags.includes(dogId)) {
      updatePhotoAtIndex(activePhotoIndex, { tags: [...photo.tags, dogId] });
    }
  };

  const removeTag = (dogId) => {
    updatePhotoAtIndex(activePhotoIndex, {
      tags: photo.tags.filter(id => id !== dogId)
    });
  };




  console.log('PhotoEditorOverlay active index:', activePhotoIndex);
  console.log('Photo object:', photo);


  return (
    <div className="photo-editor-overlay">
      <button className="photo-editor__close" onClick={closePhotoEditor}>✕</button>
      <div className="photo-editor__image">
        
      {photo?.src ? (
        <img src={photo.src} alt="Editable" />
      ) : (
        <div style={{ color: 'white' }}>No photo source available</div>
      )}
        



      </div>
      <div className="photo-editor__controls">
        <h3>Tag Dogs</h3>
        <select onChange={(e) => addTag(parseInt(e.target.value))} value="">
          <option value="">Select a dog...</option>
          {availableDogs.map(d => (
            <option key={d.id} value={d.id}>{d.name}</option>
          ))}
        </select>
        <div className="tag-list">
          {photo.tags.map(id => {
            const dog = availableDogs.find(d => d.id === id);
            return dog && (
              <span key={id} className="tag">
                {dog.name}
                <button onClick={() => removeTag(id)}>✕</button>
              </span>
            );
          })}
        </div>

        <label>
          <input
            type="checkbox"
            checked={photo.checklist.instaWorthy}
            onChange={e => updateChecklist('instaWorthy', e.target.checked)}
          />
          Instagram Worthy
        </label>

        {photo.checklist.instaWorthy && (
          <input
            type="text"
            value={photo.checklist.instaCaption}
            onChange={e => updateCaption('instaCaption', e.target.value)}
            placeholder="Instagram Caption"
          />
        )}

        <input
          type="text"
          value={photo.checklist.roverCaption}
          onChange={e => updateCaption('roverCaption', e.target.value)}
          placeholder="Rover Caption"
        />
      </div>
    </div>
  );
};

export default PhotoEditorOverlay;
